@use "sass:map";

* {
  box-sizing: border-box;
}

// Reset UL
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

:host {
  .input-margins {
    margin: 0 16px 16px;
  }

  .mobile-scroll {
    max-height: 72vh;
    overflow-y: auto;
  }

  .mobile-scroll.floating-overlay {
    overflow: visible;
    position: relative;
    z-index: 2;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .search-buttons {
      display: flex;
      align-items: center;
      position: absolute;
      height: 48px;
      right: 7px;
      z-index: 1;
    }

    &--s1 {
      .input {
        padding: 0 46px 0 16px;
        height: 48px;
        font-size: 18px !important;
        line-height: 24px;
        font-weight: 400;

        ~ sdx-button {
          top: 0px;
          padding: 7px;
        }

        &--voice-search {
          padding-right: 92px;

          ~ sdx-button {
            &.search-button {
              right: 46px;
            }
            &.voice-button {
              right: 0px;
            }
          }
        }
      }
    }

    &--s2 {
      .input {
        padding: 0 58px 0 var(--sdx-baseline-3);
        height: 70px;
        font-size: 24px !important;
        line-height: 24px;
        font-weight: 300;

        ~ sdx-button {
          top: 0px;
          padding: 14px 9px;
          &.search-button {
            right: 0px;
          }
        }

        &--voice-search {
          padding-right: 116px;

          ~ sdx-button {
            &.search-button {
              right: 58px;
            }
            &.voice-button {
              right: 0;
            }
          }
        }
      }
    }

    .h5 {
      line-height: 24px;
      letter-spacing: -0.1px;
      font-size: 18px;
      font-weight: 600;
      margin: 8px 0 16px;
      color: #015;
      text-align: left;
      word-wrap: break-word;
    }

    .input {
      align-items: center;
      appearance: none;
      backface-visibility: hidden;
      background-color: var(--sdx-color-sc-white);
      border-radius: 12px;
      border: 1px solid var(--sdx-color-gray-tint-4);
      color: var(--sdx-color-gray-tint-3);
      display: flex;
      font: inherit;
      letter-spacing: -0.1px;
      line-height: 1.5;
      outline: none;
      user-select: text;
      width: 100%;
      caret-color: var(--sdx-color-int-blue);
      /* NOTE: folowing line is needed to ensure correct box sizing on Edge(pre
       chromium versions) on PORTAL since there, on portal pages, we override
       it with `scs-pageheader * {}` selector*/
      box-sizing: border-box;

      ~ sdx-button {
      }

      &--box-shadow {
        box-shadow: 0 0 4px 0 rgba(var(--sdx-color-gray), 0.2);
      }

      // For IE11, ::placeholder does not seem to be an own individual element, it only
      // will make the selector stronger. Make sure this works cross browser:
      &::placeholder {
        transition: 150ms all cubic-bezier(0.4, 0, 0.2, 1);
        opacity: 1;
        color: var(--sdx-color-gray-tint-3);
      }

      &[type="search"] {
        -webkit-appearance: none;

        &::-webkit-search-cancel-button,
        &::-webkit-search-decoration {
          -webkit-appearance: none;
        }

        &::-ms-clear {
          display: none;
        }
      }

      &:focus:not([readonly]) {
        border-color: var(--sdx-color-int-blue);

        &::placeholder {
          opacity: 0;
        }
      }
    }

    .input.floating-overlay {
      z-index: 1;
    }
  }
}

.highlight {
  font-weight: 400;
  color: #1781e3;
}

.scs-search-input-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}

.line-clamp-1 {
  /* FIXME: Use text-overflow: ellipsis for this */
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 400;
  font-size: 18px;
}

.line-clamp-2 {
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 400;
  font-size: 18px;
}

scs-autocomplete.floating-overlay {
  position: absolute;
  top: 48px;
  background-color: #fff;
  border: 1px solid var(--sdx-color-gray-tint-4);
  border-radius: 0 0 12px 12px;
  padding: 0 0 18px 18px;
  border-top: none;
  // Negative margin, because 2 elements belonging together, but having rounded corners.
  margin-top: -8px;
}

scs-autocomplete-quick-link-option .line-clamp-2 {
  color: var(--sdx-color-azure);
}

scs-autocomplete-quick-link-option:hover .line-clamp-2 {
  text-decoration: underline;
}

.suggestion-type-title {
  margin: 20px 0 8px 0;
  color: #001155;
  font-weight: 600;
  font-size: 18px;
}

.suggestion-type-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.clear-recently-viewed {
  margin: 20px 0px 8px 8px;
}

@media (min-width: 480px) {
  .clear-recently-viewed {
    margin: 20px 0px 8px 32px;
  }

  .suggestion-type-title-row {
    justify-content: unset;
  }
}

.popular-search-item {
  padding: 4px 16px 4px 0;
}

.product-widget {
  display: flex;
  flex-direction: column;
  border-top: 1px solid #d6d6d6;
  margin: 24px 0 0;
  padding: 24px 0 0;
}

@media (min-width: 1024px) {
  .product-widget {
    margin: 36px 0 0;
    padding: 36px 0 0;
  }
}

@media (min-width: 1280px) {
  .product-widget {
    flex-direction: row;
    border-top: 0;
    border-left: 1px solid #d6d6d6;

    margin: 0 0 0 36px;
    padding: 0 0 0 24px;
    min-width: 360px;
  }
}

.product-item-container {
  display: flex;
  flex-direction: column;
}

@media (min-width: 1024px) {
  .product-item-container {
    flex-direction: row;
  }
}

@media (min-width: 1280px) {
  .product-item-container {
    flex-direction: column;
  }
}

.suggestions-and-quick-links-container {
  display: flex;
  flex-direction: column;

  @media (min-width: 1024px) {
    flex-direction: row;
  }
}

.suggestions-container {
  @media (min-width: 1024px) {
    margin-right: 72px;
  }
}

.autocomplete-container {
  display: flex;
  flex-direction: column;

  @media (min-width: 1280px) {
    flex-direction: row;
    justify-content: space-between;
  }
}

div.wrapper.search-root {
  display: flex;
  flex-direction: column;

  @media (min-width: 1280px) {
    flex-direction: row;
  }
}

.autocomplete-product-option {
  @media (min-width: 1024px) {
    width: 360px;
  }

  @media (min-width: 1280px) {
    width: unset;
  }
}
